import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import { myAxios } from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
import Form from "../form";
export const items = [
    {title: "Date of Incident", type: "date", required: true},
    {title: "Project Name", type:"Select", options: [], required: true}, 
    {title: "Lead on Site", type: "text"}, 
    {title: "Truck Number", type: "select",options: [], required: true}, 
    {showCondition: false, title: "Is the vehicle still safe to drive", type: "select", 
    options: [
        {value: "NA", label: "Not Applicable"},
        {value: "No", label: "No"},
        {value: "Yes", label: "Yes"},
    ], required: true}, 
    {title: "Equipment Affected", type: "text", required: true}, 
    {title: "How was this equipment damaged", type: "textarea", required: true}, 
    {title: "Were you able to complete the job despite the damage (explain on No)", type: "radio", onNo: "textarea", required: true}, 
    {title: "Approver Notes"}
];
//--------------------------------------------------------------------------------------------
export default function EquipmentDamageReport({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [truckNumbers, setTruckNumbers] = useState([]);
    const [projects, setProjects] = useState([]);
    items[1].options = projects.map(project => ({
        value: project.projectName, 
        label: project.projectName
    }));
    items[3].options = [
        {value: "NA", label: "Not Applicable"},
        ...truckNumbers.map(truckNumber => ({
            value: truckNumber, 
            label: truckNumber
        }))
    ];
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            // ------------------------------
            setShowLoader(true);
            const resTrucks = await myAxios("common/readTruckNumbers.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resTrucks) return;
            // ------------------------------
            setTruckNumbers(resTrucks.data.map(d => d.truckNumber));
            // ------------------------------
            setShowLoader(true);
            const resProjectNames = await myAxios("common/readProjectNames.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resTrucks) return;
            // ------------------------------
            setProjects(resProjectNames.data);
        }
        getData();
        return () => {isMounted = false;}
    },[]);
    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}

            items = {items}
            
            picsLimit = {0}
        />
    )    
}